<template>
  <h3 class="font-semibold text-gray-700 text-xl">Exportable - Descarte</h3>
  <div class="flex justify-around my-4 pr-16">
    <div class="space-x-4 items-center">
      <div>
        <p class="text-sm font-medium uppercase leading-4">Exportable (Kg)</p>
        <p class="font-bold text-2xl inline-flex items-center space-x-2">
          {{ numberWithPrecision(total_ok) }}
        </p>
      </div>
    </div>
    <div class="space-x-4 items-center">
      <div>
        <p class="text-sm font-medium uppercase leading-4">Descarte (Kg)</p>
        <p class="font-bold text-2xl inline-flex items-center space-x-2">
          {{ numberWithPrecision(total_discard) }}
        </p>
      </div>
    </div>
  </div>
  <div id="chart5">
    <apexchart
      height="350"
      width="100%"
      :options="options"
      :series="series"
    ></apexchart>
  </div>
</template>

<script>
import VueApexCharts from "vue3-apexcharts";

export default {
  name: "PRODReportingLiquidationsShowReportsGraphicsOkDiscardMonthly",
  components: {
    apexchart: VueApexCharts
  },
  props: { data: { required: true } },
  data() {
    return {
      series: [
        {
          name: "Exportable",
          data: this.data.ok,
          type: 'column'
        },
        {
          name: "Descarte",
          data: this.data.discard,
          type: 'column'
        },
        {
          name: 'Precio/Kg',
          data: this.data.usd_per_kg,
          type: 'line'
        },
        {
          name: 'Monto total',
          data: this.data.total_amount,
          type: 'line'
        },
      ],
      options: {
        chart: {
          height: 350,
          type: 'line',
          stacked: [true, true, false, false],
          toolbar: { show: true },
          zoom: { enabled: true }
        },
        responsive: [
          {
            breakpoint: 480,
            options: {
              legend: {
                position: "bottom",
                offsetX: -10,
                offsetY: 0
              }
            }
          }
        ],
        plotOptions: {
          bar: {
            horizontal: false,
            borderRadius: 2,
            columnWidth: this.barWidth(),
            dataLabels: {
              total: {
                enabled: false,
                style: { fontSize: "13px" }
              }
            }
          }
        },
        stroke: {
          width: [0, 0, 4, 4]
        },
        labels: this.data.months,
        xaxis: {
        },
        yaxis: [
          {
            title: {
              text: 'Kilogramos',
            },
            min: 0,
            max: Math.max(...this.data.ok.map(n => Number(n))) + Math.max(...this.data.discard.map(n => Number(n))),
            labels: {
              formatter: function (val) {
                return this.numberWithPrecision(val, 0);
              }.bind(this)
            }
          },
          {
            title: {
              text: 'Kilogramos',
            },
            show: false,
            min: 0,
            max: Math.max(...this.data.ok.map(n => Number(n))) + Math.max(...this.data.discard.map(n => Number(n))),
            labels: {
              formatter: function (val) {
                return this.numberWithPrecision(val, 0);
              }.bind(this)
            }
          },
          {
            opposite: true,
            title: {
              text: 'USD'
            },
            min: 0,
            max: 5,
            show: false,
            labels: {
              formatter: function (val) {
                return "$" +this.numberWithPrecision(val, 0);
              }.bind(this)
            }
          },
          {
            opposite: true,
            title: {
              text: 'USD'
            },
            min: 0,
            max: 1.5 * (Math.max(...this.data.total_amount) + Math.max(...this.data.usd_per_kg)),
            show: true,
            labels: {
              formatter: function (val) {
                return "$" +this.numberWithPrecision(val, 0);
              }.bind(this)
            }
          }
        ],
        dataLabels: {
          enabled: true,
          enabledOnSeries: [2],
          formatter: function (val) {
            return this.numberWithPrecision(val, 2);
            // formatter: function (val, { globals, dataPointIndex }) {
              // const percent =
            //   (val /
            //     (globals.series[0][dataPointIndex] +
            //       globals.series[1][dataPointIndex])) *
            //   100;
            // return this.numberWithPrecision(percent, 1) + "%";
          }.bind(this)
        },
        tooltip: {
          y: [
            {
              formatter: function (val) {
                return this.numberWithPrecision(val);
              }.bind(this)
            },
            {
              formatter: function (val) {
                return this.numberWithPrecision(val);
              }.bind(this)
            },
            {
              formatter: function (val) {
                return "$" + this.numberWithPrecision(val, 2) + " por Kg";
              }.bind(this)
            },
            {
              formatter: function (val) {
                return "$" + this.numberWithPrecision(val);
              }.bind(this)
            },
          ]
        },
        legend: {
          position: "right",
          offsetY: 40
        },
        fill: {
          opacity: 1
        },
        colors: ["#65A30D", "#CC3333", "#f97316", "#3b82f6"]
      }
    };
  },
  computed: {
    total_ok() {
      return this.data.ok.reduce((sum, val) => sum + Number(val), 0);
    },

    total_discard() {
      return this.data.discard.reduce((sum, val) => sum + Number(val), 0);
    },
    max_total() {
      return Math.max(this.data.ok) + Math.max(this.data.discard);
    }
  },
  methods: {
    barWidth() {
      if (this.data.months.length < 3) return "20%";
      if (this.data.months.length < 6) return "50%";
      return "70%";
    }
  }
};
</script>
